import { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

/**
 * Componente que renderiza un botón con tooltip preconfigurado
 * @param {string} tooltip - Texto a mostrar en el tooltip
 * @param {function} onClick - Acción al hacer clic
 * @param {string} icon - Clase del icono (ej: "fas fa-edit")
 * @param {string} [variant="secondary"] - Variante del botón Bootstrap
 * @param {string} [size="sm"] - Tamaño del botón
 * @param {object} [options] - Otras opciones (placement, delay, etc.)
 */
const TooltipButton = ({
  tooltip,
  onClick,
  icon,
  className,
  options = { placement: "top", delay: { show: 200, hide: 100 } },
}) => {

   // 🧠 Generar un ID único aleatorio (por ejemplo: tooltip-abc123)
  const tooltipId = useMemo(
    () => `tooltip-${Math.random().toString(36).substring(2, 10)}`,
    []
  );

  return (
    <OverlayTrigger placement={options.placement} delay={options.delay} overlay={<Tooltip id={`tooltip-${tooltipId}`}>{tooltip}</Tooltip>}>
      <button className={className} type="button"
        style={{ margin: "0 auto" }} onClick={onClick}>
        <i className={`${icon} pointer`} />
      </button>
    </OverlayTrigger>
  );
};

export default TooltipButton;
